<template>
  <div>
    <DirectoryTable
      title="Действия"
      :table-headers="tableHeaders"
      :data-loaded="dataLoaded"
      :table-loading="tableLoading"
      :data="actionList.list"
      @edit="edit"
      @remove="remove"
      @addBtnClick="dialog = true"
    />

    <ActionDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @save="saveAction"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeAction"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import { actionApi } from '@/api'
import { ActionList } from '@/models'
import ActionDialog from '@/components/Spm/Directories/Action/dialogs/ActionDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import DirectoryTable from '@/components/Spm/Directories/DirectoryTable'

export default {
  name: 'ActionPage',

  metaInfo: { title: 'Действия' },

  components: {
    DirectoryTable,
    ActionDialog,
    ConfirmDialog,
  },

  async created() {
    await this.getActionParent()
    this.dataLoaded = true
  },

  data: () => ({
    filter: '',
    tableHeaders: [
      { text: 'id', value: 'id', sortable: false, align: 'start' },
      { text: 'Название', value: 'name', sortable: false, align: 'start' },
      { text: 'Порядок', value: 'inOrder', sortable: false, align: 'start' },
      { text: 'Парное', value: 'isPairText', sortable: false, align: 'start' },
      { text: 'Фиксирует время', value: 'isTimeFixText', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' },
    ],
    actionList: new ActionList(),

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
  }),

  methods: {
    async getActionParent() {
      try {
        const data = await actionApi.getCatalog()
        if (data.length) data.forEach((obj) => this.actionList.add(obj))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки действий')
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },

    async saveAction(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await actionApi.update(body) : await actionApi.create(body)
        body.id ? this.actionList.update(data) : this.actionList.add(data)
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeAction() {
      try {
        this.removeLoading = true
        await actionApi.remove(this.selectedItem.id)
        this.actionList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },
  },
}
</script>
